import React from 'react';
import { IconButton, CircularProgress } from '@mui/material';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';

interface CameraFlipButtonProps {
  onFlip: () => void;
  isSwitching: boolean;
  disabled?: boolean;
}

export const CameraFlipButton: React.FC<CameraFlipButtonProps> = ({ onFlip, isSwitching, disabled = false }) => {
  return (
    <IconButton
      onClick={onFlip}
      disabled={disabled || isSwitching}
      aria-label="flip camera"
      sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 3,
        width: 44,
        height: 44,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        color: '#fff',
        backdropFilter: 'blur(8px)',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        '&:active': {
          transform: 'scale(0.92)',
        },
        '&.Mui-disabled': {
          color: 'rgba(255, 255, 255, 0.4)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      {isSwitching ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : <CameraswitchIcon />}
    </IconButton>
  );
};

export default CameraFlipButton;
